export  const checkIfWebtoolExists = (dataset,webtoolId) => {
    let check = dataset.find(i => i.webtools_id === webtoolId);
    if(check){
        return check.is_active;
    }
    return false;
}